import { MingcutePackageLine } from '../../../assets/icons/Icons';
import { useDispatch,  } from 'react-redux';
import { Package } from '../../../types/package';
import { setTypeOfAdditionalModal, setTypeOfShowModalType } from '../../../features/modal/modalSlice';
import { setPackageDetails, setPackageStatus, setSelectedPackageId, updateNewPackageTitleData } from '../../../features/package/packageSlice';
import { Default, setSelectedPackageView } from '../../../features/client/clientSlice';

interface PackageItemsProps {
    pack: Package;
    typeOfUser: 'admin' | 'user' | undefined;
}

export default function PackageItems({ pack, typeOfUser }: PackageItemsProps) {

    const dispatch = useDispatch();
    const packageId = Number(pack.packageID);
    const formatted = pack.totalValue.toLocaleString();
    const packageStatus = pack.isActive ? 'Active' : 'Inactive';
    const statusBtn = pack.isActive ? 'Inactivate' : 'Activate';
    const statusToBeUpdate = pack.isActive ? 'inactivate' : 'activate';
    const typeOfPackage = pack.packageType === 'basic' ? 'basic' : pack.packageType === 'additional' ? 'additional' : pack.packageType === 'special' ? 'special' : null;
    
    const selectedPackage: Default = {
        id: Number(pack.packageID),
        name: pack.packageName,
    }

    const handleSelectedPackage = (selectedPackage: Default) => {
        dispatch(setSelectedPackageView(selectedPackage));
        dispatch(setTypeOfAdditionalModal('viewPackageItem'))
    }
    // basic 60; special 15
    const disabledPackageIds = new Set([15, 60]);
    const isPackageStatusDisabled = disabledPackageIds.has(packageId);

    const isActive = packageStatus === "Active" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
    
    return (
        <div key={pack.packageID} className='rounded border-t-8 border-cbColor'>
            <div className='border border-gray-200 flex flex-col p-2.5 space-y-3 rounded-b bg-gray-100'>
                <div className='flex justify-between flex-row-reverse items-center'>
                    <MingcutePackageLine height={25} width={25}/> 
                    <p title={pack.packageName} className='text-xs lg:text-sm font-medium truncate'>{pack.packageName}</p>
                </div>
                <div className='grid grid-cols-3 divide-x divide-gray-300'>
                    <div className='space-y-0.5 px-1'>
                        <div className='uppercase text-[10px] text-gray-600 text-center'>Amount</div>
                        <div className='text-xs lg:text-sm font-medium text-center'>{`${formatted}`}</div>
                    </div>
                    <div className='space-y-0.5 px-1'>
                        <div className='uppercase text-[10px] text-gray-600 text-center'>CUPS</div>
                        <div className='text-xs lg:text-sm font-medium text-center'>{pack.quantity}</div>
                    </div>
                    <div className='space-y-0.5 px-1'>
                        <div className='uppercase text-[10px] text-gray-600 text-center'>STATUS</div>
                        <div className={`text-[11px] rounded font-medium text-center ${isActive}`} >
                            {packageStatus}
                        </div>
                    </div>
                </div>
                <div className={`grid ${typeOfUser === 'admin' ? 'grid-cols-3' : 'grid-cols-1'} gap-1`}>
                    <button 
                        onClick={() => handleSelectedPackage(selectedPackage)}
                        className='flex justify-center items-center text-[12px] p-1 rounded border border-gray-300 bg-gray-300 text-black'
                    >
                        View
                    </button>
                    {typeOfUser === 'admin' && (
                        <>
                        <button 
                            disabled={isPackageStatusDisabled}
                            onClick={() => {
                                dispatch(setTypeOfShowModalType('isUpdateStatusOfPackage'));
                                dispatch(setPackageStatus({packageName: pack.packageName, status: statusToBeUpdate}))
                                dispatch(setSelectedPackageId(packageId));
                                dispatch(setPackageDetails({packageType: typeOfPackage, typeOfAction: null}));
                            }}
                            className='flex justify-center items-center text-[12px] p-1 rounded border border-gray-300 bg-cbColor text-white disabled:cursor-not-allowed'
                        >
                            {statusBtn}
                        </button>
                        <button 
                            onClick={() => {
                                dispatch(setTypeOfShowModalType('updatePackageModal'));
                                dispatch(setSelectedPackageId(packageId));
                                dispatch(setPackageDetails({packageType: typeOfPackage, typeOfAction: null}));
                                dispatch(
                                    updateNewPackageTitleData({
                                        packageName: pack.packageName ?? "",
                                        description: "",
                                        quantity: pack.quantity ?? 0,
                                        totalValue: pack.totalValue ?? 0,
                                        discountPercentage: pack.discountPercentage ?? 0,
                                        canExceed: pack.canExceed ?? false
                                    })
                                );
                            }}
                            className='flex justify-center items-center text-[12px] p-1 rounded border border-gray-300 bg-cbColor text-white'
                        >
                            Update
                        </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
